export const noop = () => {};

// disables a control
export const disabled = {
  control: {
    disable: true,
  },
};

// hides a prop from prop table and controls
export const hidden = {
  table: {
    disable: true,
  },
};

export const title = (name: string) => `components/${name}`;

export const guidelinesTitle = (name: string) =>
  `components/${name}/Guidelines`;

export const docsTitle = (name: string) => `documentation/${name}`;
